var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFuente(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1201 3.47561C12.5115 3.10998 13.0355 2.90997 13.5754 2.90997C14.1152 2.90997 14.6393 3.10998 15.0307 3.47561C15.4232 3.84231 15.6508 4.34724 15.6508 4.88156C15.6508 5.15771 15.4269 5.38156 15.1508 5.38156C14.8746 5.38156 14.6508 5.15771 14.6508 4.88156C14.6508 4.63531 14.5464 4.39163 14.3481 4.20638C14.1486 4.02005 13.8712 3.90997 13.5754 3.90997C13.2796 3.90997 13.0022 4.02005 12.8027 4.20638C12.6044 4.39163 12.5 4.6353 12.5 4.88156V9.14475C12.5 9.42089 12.2761 9.64475 12 9.64475C11.7239 9.64475 11.5 9.42089 11.5 9.14475V4.88156C11.5 4.34724 11.7275 3.84231 12.1201 3.47561Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8799 5.37185C11.4885 5.00622 10.9645 4.80621 10.4246 4.80621C9.88476 4.80621 9.36074 5.00622 8.96932 5.37185C8.57675 5.73855 8.34921 6.24348 8.34921 6.7778C8.34921 7.05395 8.57307 7.2778 8.84921 7.2778C9.12535 7.2778 9.34921 7.05395 9.34921 6.7778C9.34921 6.53155 9.45363 6.28787 9.65194 6.10262C9.85142 5.91629 10.1288 5.80621 10.4246 5.80621C10.7204 5.80621 10.9978 5.91629 11.1973 6.10262C11.3956 6.28787 11.5 6.53154 11.5 6.7778V9.20322C11.5 9.47936 11.7239 9.70322 12 9.70322C12.2761 9.70322 12.5 9.47936 12.5 9.20322V6.7778C12.5 6.24348 12.2725 5.73855 11.8799 5.37185Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 15.9014H6.5C5.94772 15.9014 5.5 16.3491 5.5 16.9014V19.59H18.5V16.9014C18.5 16.3491 18.0523 15.9014 17.5 15.9014ZM6.5 14.9014C5.39543 14.9014 4.5 15.7968 4.5 16.9014V20.59H19.5V16.9014C19.5 15.7968 18.6046 14.9014 17.5 14.9014H6.5Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 10.2128C9.5 9.38434 10.1716 8.71276 11 8.71276H13C13.8284 8.71276 14.5 9.38433 14.5 10.2128V14.9014H13.5V10.2128C13.5 9.93662 13.2761 9.71276 13 9.71276H11C10.7239 9.71276 10.5 9.93662 10.5 10.2128V14.9014H9.5V10.2128Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuente);
export default __webpack_public_path__ + "static/media/fuente.51c85dc97ffc17bc0678a2f31b674aa8.svg";
export { ForwardRef as ReactComponent };